// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ghCo","label":"styles_label__FnGLM"};